import { HttpGetAmaReplacementDetails } from '@/service/boss/b2corder';
import TableList from "@components/templates/tablelist";
export default {
    props:["id"],
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            // Plugins: {show: true},
            showPage:false
        };
    },
    methods: {
        ajaxRequest: HttpGetAmaReplacementDetails,
        startUp:0,
        interceptResponse(data, _this) {
            this.dataList=data
            this.total=this.dataList.length
		}
    },
    computed: {
        columns() {
            return [
                {
                    title: "OrderNo",
                	key: 'orderNo',
                },
                {
                	title: "SKU",
                	key: 'sku',
                },
                {
                	title: "ASIN",
                	key: 'asin'
                },
                {
                	title: "Quantity",
                	key: 'qty',
                }];
        },
    },
};





